import {
    Component,
    ViewChild,
    TemplateRef,
    OnInit,
    OnDestroy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
// -- components --
import { SubTabsComponent } from '../components/sub-tabs/sub-tabs.component';
import { Step1Component } from './components/step-1/step-1.component';
import { Step2Component } from './components/step-2/step-2.component';
import { Step3Component } from './components/step-3/step-3.component';
// -- models --
import { TabOption } from '../components/sub-tabs/sub-tabs.component';
// -- services --
import { Jc3Service } from '../jc3.service';
import { ToastrService } from 'ngx-toastr';
import { TabNavigationHandlerService } from '../services/tab-navigation-handler.service';

@Component({
    selector: 'app-financing-solutions',
    standalone: true,
    imports: [
        SubTabsComponent,
        CommonModule,
        Step1Component,
        Step2Component,
        Step3Component,
    ],
    providers: [TabNavigationHandlerService],
    templateUrl: './financing-solutions.component.html',
    styleUrl: './financing-solutions.component.scss',
})
export class FinancingSolutionsComponent implements OnInit, OnDestroy {
    tabs: TabOption[] = [];
    financingInfoData: any[] = [];
    fsData: any = [];
    fsCards: any = [];
    mainData: any = [];
    grantsData: any = [];
    finproData: any = [];
    schemeData: any = [];
    stepData: any = [];

    @ViewChild('step1') step1!: TemplateRef<any>;
    @ViewChild('step2') step2!: TemplateRef<any>;
    @ViewChild('step3') step3!: TemplateRef<any>;

    constructor(
        private jc3Service: Jc3Service,
        private toastr: ToastrService,
        public tabHandler: TabNavigationHandlerService
    ) {}

    ngOnInit(): void {
        this.tabHandler.initialize({
            mainTabName: 'financing-solutions',
            tabs: this.tabs,
        });
        this.getFinancingInfoData();
    }

    private setupTabs(): void {
        if (!this.fsData) return;

        this.tabs = [
            {
                label: this.finproData?.switchername,
                value: 'FINPRO',
                // value: this.fsData?.switcher1alias?.toLowerCase(),
                template: this.step1,
            },
            {
                label: this.grantsData?.switchername,
                value: 'GRANTS',
                // value: this.fsData?.switcher2alias?.toLowerCase(),
                template: this.step2,
            },
            {
                label: this.schemeData?.switchername,
                value: 'INSURANCE',
                // value: this.fsData?.switcher3alias?.toLowerCase(),
                template: this.step3,
            },
        ];

        // Update tabs in the handler service
        this.tabHandler.updateTabs(this.tabs);
    }

    ngAfterViewInit() {
        this.setupTabs();
    }

    ngOnDestroy(): void {
        this.tabHandler.ngOnDestroy();
    }

    getFinancingInfoData() {
        this.jc3Service.getFinancialSolutionsTitleSwitcher().subscribe({
            next: (res) => {
                this.fsData = res;
                this.mainData = this.fsData?.find(
                    (item) => item.switcher1alias === 'MAINTITLE'
                );
                this.grantsData = this.fsData?.find(
                    (item) => item.switcher1alias === 'GRANTS'
                );
                this.finproData = this.fsData?.find(
                    (item) => item.switcher1alias === 'FINPRO'
                );
                this.schemeData = this.fsData?.find(
                    (item) => item.switcher1alias === 'SCHEME'
                );
                this.setupTabs();
            },
            error: (err) => {
                console.log('error', err);
            },
        });

        this.jc3Service.getFinancialSolutionsCards().subscribe({
            next: (res) => {
                this.fsCards = res;
                this.stepData[0] = this.getCardsForSwitcherGroup('FINPRO');
                this.stepData[1] = this.getCardsForSwitcherGroup('GRANTS');
                this.stepData[2] = this.getCardsForSwitcherGroup('INCENTIVES');
                this.setupTabs();
            },
            error: (err) => {
                console.log('error', err);
            },
        });
    }

    getCardsForSwitcherGroup(switcherGroup: string): any[] {
        if (!this.fsCards) return [];

        const today = new Date();

        return this.fsCards.filter((card) => {
            const publishDate = new Date(card.publishdate);
            return card.switchergroup === switcherGroup && publishDate <= today;
        });
    }
}
